import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import { Column } from 'styled-components-reactive-grid';

import ONCallSquareIcon from 'components/ONCallSquareIcon';

import { IMPORTANT_SERVICE_CODES } from './constants';

function ServiceSummaryIcons({ services, tooltipPositions }) {
  if (!services.length) {
    return null;
  }

  const serviceCodes = services.map(f => f.code);

  function setActiveModifier(code) {
    const active = serviceCodes.includes(code) && 'active';
    return compact([active]);
  }

  function setToolTipPosition(i) {
    // to supress tooltips simply ignore the prop
    if (!tooltipPositions) {
      return '';
    }

    // to make the API more friendly :)
    // instead of passing: tooltipPositions={['top', 'top', 'top', 'top']}
    // do this: tooltipPositions={['top']}
    if (tooltipPositions.length === 1) {
      return tooltipPositions[0];
    }

    // to explicitly state tooltip directions:
    // tooltipPositions={['top', 'left', 'bottom', 'right']}
    // ordered from left to right
    return tooltipPositions[i];
  }

  return (
    <Fragment>
      {IMPORTANT_SERVICE_CODES.map((code, i) => (
        <Column key={code}>
          <ONCallSquareIcon
            code={code}
            modifiers={setActiveModifier(code)}
            tooltipPosition={setToolTipPosition(i)}
          />
        </Column>
      ))}
    </Fragment>
  );
}

ServiceSummaryIcons.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
    }),
  ),
  tooltipPositions: PropTypes.arrayOf(PropTypes.string),
};

ServiceSummaryIcons.defaultProps = {
  services: [],
  tooltipPositions: [],
};

export default ServiceSummaryIcons;



// WEBPACK FOOTER //
// ./src/components/ServiceSummaryIcons/index.js